import axios from "axios";
//import qs from 'qs'
import { store } from "Store/index";
import { baseUrlApis } from "./index";
import { URL_PLATFORM } from './constants';
import { HttpRequest } from './request.utils'
import { getProductNameForDashboard } from '@/utils/utils';
const WebToolAPIs = {
  baseUrl: "",
  baseHttpUrl: "",
  checkDashboardPermission:'platform/api/policy/check'
};
//https://pheeplatform-fzk8s.connectedpdf.com/platform/rest/fs/

function _GetPlatformToken(flag){
  if (!flag) {
    return store.userStore.token;
  }
  // 8003 5dbf8cd15764542e96a30fcb
  // 8081 5dbf8765a09af17dfce13d76
  return '5dbf986c603d5c6237f37ea0';
}

/**
 *
 *
 */

export class PlatformApis extends HttpRequest {
  constructor() {
    super();
    this.CPDFURI = '';
  }
  initialize = () => {
    try {
      baseUrlApis.getBaseUrlBy(URL_PLATFORM).then((data) => {
        this.CPDFURI = data;
        let axiosClient = axios.create({
          baseURL: this.CPDFURI,
        });
        super.initialize(axiosClient, () => {
          this.interceptorsFn();
        });
      });
    } catch (error) {
      throw error;
    }
  }
  doGetRequest = async (url, callback) => {
    let result = await this.get({ url });
    if (result && result.ret != void 0) {
      callback && callback(result);
      return;
    }
    throw result;
  }

  // PSPRD-514  /api/policy/check
  checkDashboardPermission = async ()=>{
    const url = `/${WebToolAPIs.checkDashboardPermission}`;
    const config = {
      params: {
        access_token:_GetPlatformToken(),
        product: getProductNameForDashboard()
      }
    }

    try {
      let result = await this.get({ url, config });
      return Promise.resolve(result);
    } catch (error) {
      console.error('TCL: PlatformApis -> checkDashboardPermission -> error:',error)
      return Promise.reject(error);
    }
  }
}